'use client';

import { LogOut } from 'lucide-react';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { userSelector } from '@/redux/user/user.selectors';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { logout } from '@/redux/user/user.thunks';
import { useRouter } from 'next/router';
import { SidebarMenu, SidebarMenuItem } from '@/shared/shadcn/components/sidebar';
import { Button } from '@/shared/shadcn/components/button';

export const NavUser = (): JSX.Element => {
  const { login, userData } = useAppSelector(userSelector);
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleLogout = async (): Promise<void> => {
    await dispatch(logout());
    router.push('/');
  };

  const fullName = userData ? `${userData.name || ''} ${userData.surname || ''}`.trim() : null;

  return (
    <SidebarMenu>
      <SidebarMenuItem className="flex items-center">
        <div className="flex-1 p-2">
          <div className="grid flex-1 text-left text-sm">
            {fullName && <span className="truncate text-xs font-medium">{fullName}</span>}
            {login && <span className="truncate text-xs text-gray-500">{login}</span>}
          </div>
        </div>
        <Button variant="ghost" size="icon" onClick={handleLogout} className="ml-2 h-8 w-8 p-0">
          <LogOut className="h-4 w-4" />
        </Button>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
